import React from 'react'
import { Grid } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { change, formValueSelector } from 'redux-form'

// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'

import { isRequired } from '../../../helpers'
import { FORM_NAME } from '../../../constants'
import translate from '../../translate'

@(connect(
  // @ts-ignore
  (state, { fields }) => {
    const selector = formValueSelector(FORM_NAME)

    return {
      ORG_IndustrySubDetailID: fields.ORG_IndustrySubDetailID
        ? selector(state, fields.ORG_IndustrySubDetailID.FName)
        : undefined,
    }
  },
  (dispatch) => ({
    setIndustrySubDetailID: (value) => {
      dispatch(change(FORM_NAME, 'ORG_IndustrySubDetailID', value))
    },
  }),
) as any)
class BusinessInformation extends React.Component<any> {
  handleIndustryIDChange = () => {
    const { fields, dynamicOptions, ORG_IndustrySubDetailID, setIndustrySubDetailID } = this.props

    if (
      fields.ORG_IndustrySubDetailID &&
      !dynamicOptions.IndustrySubDetail.find((option) => option.ORG_IndustrySubID === ORG_IndustrySubDetailID)
    ) {
      setIndustrySubDetailID(1) // Select default ID 1 for undefined if not found previous selected ID.
    }
  }

  render() {
    const { fields, selects, dynamicOptions, noVisibilityFilter } = this.props

    return (
      <Grid.Column style={{ borderBottom: '1px solid rgba(34,36,38,.15)' }}>
        {!!fields.ORG_IndustryID && (
          <FormLayout
            visible={noVisibilityFilter || !!(fields.ORG_IndustryID || fields.ORG_IndustrySubID)}
            label={translate('lbl_pers_industry')}
            labelFieldProportions="5:11"
          >
            <FormField
              name="ORG_IndustryID"
              visible={noVisibilityFilter || !!fields.ORG_IndustryID}
              options={selects.Industry}
              type="select"
              search
              flags={
                // don't pass any flags if ORG_IndustrySubID is turned off
                fields.ORG_IndustrySubID && {
                  modifies: {
                    modifier: 'ORG_IndustryID',
                    field: { ORG_IndustrySubID: selects.Subindustry },
                    form: FORM_NAME,
                  },
                }
              }
              required={isRequired(fields.ORG_IndustryID)}
              childOptions={selects.Subindustry}
              customOnChange={this.handleIndustryIDChange}
            />
          </FormLayout>
        )}

        {(!!fields.BusinessTypeID || !!fields.ORG_IndustrySubID || !!fields.ORG_IndustrySubDetailID) && (
          <FormLayout
            label={translate(' ')}
            visible={noVisibilityFilter || !!fields.BusinessTypeID}
            labelFieldProportions="5:11"
          >
            {!!fields.ORG_IndustrySubID && (
              <FormField
                name="ORG_IndustrySubID"
                visible={noVisibilityFilter || !!fields.ORG_IndustrySubID}
                options={dynamicOptions.Subindustry}
                required={isRequired(fields.ORG_IndustrySubID)}
                type="select"
                search
                floatLeft
                flags={
                  // don't pass any flags if ORG_IndustrySubDetailID is turned off
                  fields.ORG_IndustrySubDetailID && {
                    modifies: {
                      modifier: 'ORG_IndustrySubID',
                      field: { ORG_IndustrySubDetailID: selects.IndustrySubDetail },
                      form: FORM_NAME,
                    },
                  }
                }
                childOptions={selects.IndustrySubDetail}
              />
            )}
            {!!fields.ORG_IndustrySubDetailID && (
              <FormField
                name="ORG_IndustrySubDetailID"
                visible={noVisibilityFilter || !!fields.ORG_IndustrySubDetailID}
                options={dynamicOptions.IndustrySubDetail}
                required={isRequired(fields.ORG_IndustrySubDetailID)}
                type="select"
                search
                floatLeft
              />
            )}
          </FormLayout>
        )}
        {!!fields.BusinessTypeID && (
          <FormLayout
            label={translate('lbl_businesstype')}
            visible={noVisibilityFilter || !!fields.BusinessTypeID}
            labelFieldProportions="5:11"
          >
            <FormField
              name="BusinessTypeID"
              required={isRequired(fields.BusinessTypeID)}
              type="text"
              maxLength={fields.BusinessTypeID ? fields.BusinessTypeID.MaxLen : -1}
            />
          </FormLayout>
        )}

        {!!fields.IND_RegisteredBusinessID && (
          <FormLayout
            label={translate('lbl_registered')}
            visible={noVisibilityFilter || !!fields.IND_RegisteredBusinessID}
            labelFieldProportions="5:11"
          >
            <FormField
              name="IND_RegisteredBusinessID"
              options={selects.Registered}
              required={isRequired(fields.IND_RegisteredBusinessID)}
              type="select"
              search
            />
          </FormLayout>
        )}
        {!!fields.IND_StaticBusinessID && (
          <FormLayout
            label={translate('lbl_static')}
            visible={noVisibilityFilter || !!fields.IND_StaticBusinessID}
            labelFieldProportions="5:11"
          >
            <FormField
              name="IND_StaticBusinessID"
              options={selects.StaticBusiness}
              required={isRequired(fields.IND_StaticBusinessID)}
              type="select"
              search
            />
          </FormLayout>
        )}
        {!!fields.LicenseCardNumber && (
          <FormLayout
            label={translate('lbl_licensenumber')}
            visible={noVisibilityFilter || !!fields.LicenseCardNumber}
            labelFieldProportions="5:11"
          >
            <FormField
              name="LicenseCardNumber"
              required={isRequired(fields.LicenseCardNumber)}
              type="text"
              maxLength={fields.LicenseCardNumber ? fields.LicenseCardNumber.MaxLen : -1}
            />
          </FormLayout>
        )}
      </Grid.Column>
    )
  }
}

export default BusinessInformation
